/**
 * Sets component data based on configuration object
 *
 * @param   {object}  instance  Vue instance
 * @param   {object}  config  Object with configuration
 *
 */
export default (instance, config) => {
    for (const key in config) {
        instance[key] = config[key];
    }
};
